import { render } from "./homeStudioDetail.vue?vue&type=template&id=470c42aa&scoped=true"
import script from "./homeStudioDetail.vue?vue&type=script&lang=js"
export * from "./homeStudioDetail.vue?vue&type=script&lang=js"

import "./homeStudioDetail.vue?vue&type=style&index=0&id=470c42aa&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470c42aa"]])

export default __exports__